if (!customElements.get('anchor-nav')) {
  class AnchorNav extends ObservedElement {
    constructor() {
      super();
      this.navLinks = Array.from(this.querySelectorAll('ul a'));
      this.navTargets = this.navLinks.map(link =>
        document.querySelector(link.getAttribute('href'))
      );
      this.clickEventListeners = [];

      const header = document.querySelector('#shopify-section-header');
      this.addIntersectionObserver(this, this.onIntersect, {
        onIntersect: false,
        rootMargin: () =>
          `${1 - header.offsetHeight}px 0px ${
            header.offsetHeight + this.offsetHeight - window.innerHeight
          }px 0px`,
        threshold: [1],
      });
      this.addIntersectionObserver(this.navTargets, this.onTargetIntersect, {
        rootMargin: () => {
          const rootMarginOffset = 0 - header.offsetHeight - this.offsetHeight;

          return `${rootMarginOffset}px 0px 0px 0px`;
        },
        threshold: () => {
          const containerSize =
            window.innerHeight - header.offsetHeight - this.offsetHeight;

          const maxTargetHeight = Math.max.apply(
            null,
            this.navTargets.map(target => target.offsetHeight)
          );

          return Math.min(
            roundToChunk(containerSize / maxTargetHeight, 4, {
              method: 'floor',
            }),
            1
          );
        },
      });

      this.resetOnResize();
    }

    connectedCallback() {
      super.connectedCallback();
      for (const link of this.navLinks) {
        this.clickEventListeners.push(initAnchor(link));
      }
    }

    disconnectedCallback() {
      super.disconnectedCallback();
      for (const listener of this.clickEventListeners) {
        listener.remove();
      }
      this.clickEventListeners = [];
    }

    onIntersect(entry, observer) {
      this.classList.toggle('is-active', entry.isIntersecting);
    }

    onTargetIntersect(entry, observer) {
      const { target } = entry;

      const targetLink = this.navLinks.find(
        link => link.getAttribute('href').replace('#', '') === target.id
      );

      this.setActiveLink(targetLink);
    }

    setActiveLink(link) {
      this.classList.add('has-active-link');

      this.navLinks.forEach(navLink => {
        navLink.classList.remove('is-active');
      });

      link.classList.add('is-active');
    }
  }

  customElements.define('anchor-nav', AnchorNav);
}
